document.addEventListener('DOMContentLoaded', () => {
  const price = document.querySelector('.pdp-price');
  const priceBanner = document.querySelector('.pdp-sticky-banner__price');
  const stickyBtn = document.querySelector('.pdp-sticky-banner__btn');
  const submitBtn = document.querySelector('.product:not(.featured-product) .product-form__submit');
  const banner = document.querySelector('.pdp-sticky-banner');
  const footer = document.querySelector('footer');
  const initialFooterPaddingTop = parseFloat(getComputedStyle(footer).paddingTop) || 0;
  const customDiscount = price?.querySelector('.custom-discount');
  const variantInput = document.querySelector('.product:not(.featured-product) .product-variant-id');
  const promoBlock = document.querySelectorAll('.pdp-sticky-banner__promo');



  if (price && priceBanner) {
    const copyContent = () => {
      const price = document.querySelector('.pdp-price');
      priceBanner.innerHTML = '';
      price.childNodes.forEach(node => {
        priceBanner.appendChild(node.cloneNode(true));
      });
    };


    window.updateIfBothChanged = () => {
      const price = document.querySelector('.pdp-price');
      const customDiscount = price?.querySelector('.custom-discount');
        if(customDiscount) {
          setTimeout(function() {
            if (typeof window.checkPrice === 'function') window.checkPrice();
            copyContent();
          },100);
        } else {
          copyContent();
        }

        if(promoBlock && customDiscount) {
          const promoDiscount = customDiscount.getAttribute('data-promo-discount');
          
          promoBlock.forEach(block => {
            const promoBannerText = block.textContent.trim();

            if (promoDiscount) {
              const newText = promoBannerText.replace(/\$\{.*?\}|\d+(?=%)/, promoDiscount);
              block.textContent = newText;
              block.classList.remove('m-hidden');
            }
          });
        }
    };

    window.updateIfBothChanged();

    if (variantInput) {
      const variantObserver = new MutationObserver(() => {

        const priceItem = document.querySelector('.pdp-price');

        if (priceItem) {
          const priceObserver = new MutationObserver(() => {
            window.updateIfBothChanged();
            priceObserver.disconnect();
          });
          priceObserver.observe(price, { childList: true, subtree: true, characterData: true });
        }
      });
      variantObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }

    if (stickyBtn && submitBtn) {
      stickyBtn.addEventListener('click', () => {
        submitBtn.click();
      });
    }
  }

  if (banner && customDiscount) {
    function updateChatPosition() {
      const chat = document.querySelector('#ShopifyChat');
      let trigger = 0;

      if (chat && trigger < 20) {
        if (window.innerWidth <= 768) {
          chat.style.bottom = '140px';
        } else {
          chat.style.bottom = '120px';
        }
        trigger = 0;
      } else {
        trigger++;
        setTimeout(function() {
          updateChatPosition();
        },500);
      }
    }

    updateChatPosition();
    window.addEventListener('resize', updateChatPosition);

  }

  if (banner && footer) {

    function updateFooterPadding() {
      const bannerHeight = banner.offsetHeight;
      footer.style.paddingTop = (initialFooterPaddingTop + bannerHeight - 10) + 'px';
    }

    function updateBannerPosition() {
      const bannerHeight = banner.offsetHeight;
      const windowHeight = window.innerHeight;

      updateFooterPadding();

      const footerRect = footer.getBoundingClientRect();

      if (footerRect.top < windowHeight) {
        const overlap = windowHeight - footerRect.top;
        banner.style.bottom = Math.max(overlap - bannerHeight + 15, 0) + 'px';
      } else {
        banner.style.bottom = '0';
      }
    }

    window.addEventListener('scroll', updateBannerPosition);
    window.addEventListener('resize', updateBannerPosition);

    updateBannerPosition();
  }

});
